import { useGetProjectTemplateMilestonesQuery } from 'generated/graphql';

import {
  DateTime,
  Duration
} from 'luxon';
import React from 'react';

export interface IData {
  milestones: {
    id: string;
    title: string;
    startDate: DateTime;
    endDate: DateTime;
    durationInDays: number;
  }[];
}



export function useQuery(id: string) {
  const tuple = useGetProjectTemplateMilestonesQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  // const days: { dateToColumn: string; values: Record<string, boolean> }[] = transformDate2Milestones(tuple.data?.standardTemplateMilestones ?? []);


  return React.useMemo(
    () => {
      const milestones = tuple.data?.project?.milestones ?? [];
      const data: IData = {
        milestones: milestones.map((node) => {
          const estStartDate = DateTime.fromISO(`${node.startDate}`);

          const estEndDate = estStartDate.plus(Duration.fromObject({
            days: node.durationInDays
          }));

          return {
            id: node.id,
            title: node.title,
            startDate: estStartDate,
            endDate: estEndDate,
            durationInDays: node.durationInDays,
            endDurationFromTodayMillis: estEndDate.toMillis()
          };
        }) ?? []
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
